import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RetailerHomeService } from '../../retailer-home/retailer-home.service';
import { OrderStatus, UserRole } from 'src/app/models/enums';

@Component({
  selector: 'app-delivery-report-bulk',
  templateUrl: './delivery-report-bulk.component.html',
  styleUrls: ['./delivery-report-bulk.component.scss']
})
export class DeliveryReportBulkComponent implements OnInit {
  printData:any;
  payLoad:{
    skipCount: number,
    maxResultCount: number,
    isInvloveDeletedItems: boolean,
    startDate: string,
    endDate: string,
    retailerId: number,
    keyword: string,
    isTestMode: boolean
  }
  showOrderDetails: boolean;
  constructor(private route: ActivatedRoute,private service:RetailerHomeService ) { }
  ngOnInit(): void {
    if(localStorage.getItem("RoleType").toString()==UserRole.Admin.toString()){
      this.showOrderDetails=true;
    }
    else{
      this.showOrderDetails=false;
    }
    this.route.queryParams.subscribe((params) => {

      this.payLoad = {
        skipCount: 0,
        maxResultCount: 0,
        isInvloveDeletedItems: false,
        startDate: params['startDate'].toString(),
        endDate: params['endDate'].toString(),
        retailerId: params['retailerid'].toString(),
        keyword: params['keyword'].toString(),
        isTestMode:false
      }

  });
  

  if (localStorage.getItem("TestMode") == 'true') {
    this.payLoad.isTestMode = true;
  }
  else if (localStorage.getItem("TestMode") == 'false') {
    this.payLoad.isTestMode = false
  }
  this.service.PrintCustomerDeliveryReportBulk(this.payLoad).subscribe((response:any)=>{
    this.printData=response.map(item=>({
      ...item,
      orderStatus:OrderStatus[item.orderStatus]
    }));
    console.log(this.printData);
  })
}

}
